<template>
  <template
    v-if="field.type !== 'divider' && (field?.is_search_show !== false || field_render_show)"
  >
    <slot />
    <div
      v-if="field.type === 'kong'"
      style="height: 62px; width: 200px"
    ></div>
    <!--    展示内容-->
    <div v-if="field.type === 'tag'">
      <a-tag
        :color="field.color ? field.color(field, model) : 'green'"
        :style="field.style"
        v-if="(field.content && field.content(field, model)) || model"
        @click="field.cb ? field.cb(field, model) : ''"
      >
        <span v-if="field.content">
          {{ field.content(field, model) }}
        </span>
        <span v-else>{{ model }}</span>
      </a-tag>
    </div>
    <!--    表单占位组件-->
    <!--    默认 【表单空位 高62px; 名称空位 高30px;】 如遇个别特殊表单，根据实际情况自行调节 高度-->
    <!--    height 属性必填-->
    <div
      v-if="field.type === 'kong_title'"
      :style="'height: ' + field.height + 'px'"
    ></div>
    <div
      v-if="field.type === 'title'"
      style="height: 30px; position: relative"
    >
      <span
        style="
          position: absolute;
          bottom: 0;
          padding: 0;
          margin: 0;
          font-weight: bolder;
          font-size: 17px;
        "
      >
        {{ field.name }}
      </span>
    </div>
    <a-rate
      v-if="field.type === 'rate'"
      v-model:value="model"
      :disabled="field.disabled"
      allow-half
      :style="`width: ${field_width}px`"
    />
    <a-input
      v-if="field.type === 'input'"
      v-model:value="model"
      :allow-clear="field.allowClear == undefined ? true : field.allowClear"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :maxlength="field.maxlength"
      :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
      :type="field.inputType ? field.inputType : 'text'"
      size="small"
      :style="`width: ${field_width}px`"
    >
      <template
        v-if="field?.prefix || field?.prefixIcon"
        #prefix
      >
        <span v-if="field?.prefix">{{ field.prefix }}</span>
        <component
          v-if="field?.prefixIcon"
          :is="field?.prefixIcon"
        />
      </template>
      <template
        v-if="field?.suffix || field?.suffixIcon"
        #suffix
      >
        <span v-if="field?.suffix">{{ field.suffix }}</span>
        <component
          v-if="field?.suffixIcon"
          :is="field?.suffixIcon"
        />
      </template>
      <template
        v-if="field?.addonBefore || field?.addonBeforeIcon"
        #addonBefore
      >
        <span v-if="field?.addonBefore">{{ field.addonBefore }}</span>
        <component
          v-if="field?.addonBeforeIcon"
          :is="field?.addonBeforeIcon"
        />
      </template>
      <template
        v-if="field?.addonAfter || field?.addonAfterIcon"
        #addonAfter
      >
        <span v-if="field?.addonAfter">{{ field.addonAfter }}</span>
        <component
          v-if="field?.addonAfterIcon"
          :is="field?.addonAfterIcon"
        />
      </template>
    </a-input>

    <a-input-number
      v-if="field.type === 'money'"
      size="small"
      v-model:value="model"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :disabled="field.disabled"
      :default-value="field.defaultValue"
      :min="field.min"
      :max="field.max"
      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
      :precision="field.precision"
      :step="field.step"
      :placeholder="
        field.placeholder_i18n == undefined ? field.placeholder : t(field.placeholder_i18n)
      "
      :style="`width: ${field_width}px`"
    />
    <a-input-number
      v-if="field.type === 'number'"
      v-model:value="model"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :formatter="field.formatter"
      :max="field.max"
      :min="field.min"
      :placeholder="field.placeholder ? field.placeholder : '请输入' + field.label"
      :precision="field.precision"
      :step="field.step"
      size="small"
      :style="`width: ${field_width}px`"
    >
      <template
        v-if="field?.prefix || field?.prefixIcon"
        #prefix
      >
        <span v-if="field?.prefix">{{ field.prefix }}</span>
        <component
          v-if="field?.prefixIcon"
          :is="field?.prefixIcon"
        />
      </template>
      <template
        v-if="field?.suffix || field?.suffixIcon"
        #suffix
      >
        <span v-if="field?.suffix">{{ field.suffix }}</span>
        <component
          v-if="field?.suffixIcon"
          :is="field?.suffixIcon"
        />
      </template>
      <template
        v-if="field?.addonBefore || field?.addonBeforeIcon"
        #addonBefore
      >
        <span v-if="field?.addonBefore">{{ field.addonBefore }}</span>
        <component
          v-if="field?.addonBeforeIcon"
          :is="field?.addonBeforeIcon"
        />
      </template>
      <template
        v-if="field?.addonAfter || field?.addonAfterIcon"
        #addonAfter
      >
        <span v-if="field?.addonAfter">{{ field.addonAfter }}</span>
        <component
          v-if="field?.addonAfterIcon"
          :is="field?.addonAfterIcon"
        />
      </template>
    </a-input-number>

    <template v-if="field.type === 'select'">
      <a-select
        v-if="field.mode === 'default'"
        v-model:value="model"
        :allow-clear="field.allowClear"
        :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
        :default-value="field.defaultValue"
        :disabled="field.disabled"
        :dropdownMatchSelectWidth="false"
        :maxTagCount="field.maxTagCount ? field.maxTagCount : 'responsive'"
        :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
        :show-search="!!field.show_search"
        size="small"
        :style="`width: ${field_width}px`"
      >
        <a-select-option
          v-for="option in options"
          :key="option[field.valueKey ? field.valueKey : 'value']"
          :value="option[field.valueKey ? field.valueKey : 'value']"
        >
          {{ option[field.labelKey ? field.labelKey : 'label'] }}
        </a-select-option>
      </a-select>
      <a-select
        v-else
        v-model:value="model"
        :allow-clear="field.allowClear"
        :default-value="field.defaultValue"
        :disabled="field.disabled"
        :dropdownMatchSelectWidth="false"
        :maxTagCount="field.maxTagCount ? field.maxTagCount : 'responsive'"
        :mode="field.mode"
        :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
        :show-search="!!field.show_search"
        size="small"
        :style="`width: ${field_width}px`"
      >
        <a-select-option
          v-for="(option, index) in options"
          :key="index"
          :value="option[field.valueKey ? field.valueKey : 'value']"
        >
          {{ option[field.labelKey ? field.labelKey : 'label'] }}
        </a-select-option>
      </a-select>
    </template>
    <template v-if="field.type === 'groupselect'">
      <a-select
        v-if="field.mode === 'default'"
        v-model:value="model"
        :allow-clear="field.allowClear"
        :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
        :default-value="field.defaultValue"
        :disabled="field.disabled"
        :dropdownMatchSelectWidth="false"
        :getPopupContainer="field.getPopupContainer == undefined ? null : field.getPopupContainer"
        :labelInValue="field.labelInValue === true"
        :maxTagCount="field.maxTagCount ? field.maxTagCount : 'responsive'"
        :options="options"
        :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
        :show-search="!!field.show_search"
        size="small"
        :style="`width: ${field_width}px`"
      ></a-select>
      <a-select
        v-else
        v-model:value="model"
        :allow-clear="field.allowClear"
        :default-value="field.defaultValue"
        :disabled="field.disabled"
        :dropdownMatchSelectWidth="false"
        :getPopupContainer="field.getPopupContainer == undefined ? null : field.getPopupContainer"
        :labelInValue="field.labelInValue === true"
        :maxTagCount="field.maxTagCount ? field.maxTagCount : 'responsive'"
        :mode="field.mode"
        :options="options"
        :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
        :show-search="!!field.show_search"
        size="small"
        :style="`width: ${field_width}px`"
      ></a-select>
    </template>

    <a-cascader
      v-if="field.type === 'cascader'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :multiple="field.multiple"
      :show-search="field.show_search"
      :changeOnSelect="field.changeOnSelect ? field.changeOnSelect : false"
      :options="field.getOptionsData ? field.getOptionsData(options, model) : options"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      size="small"
      :style="`width: ${field_width}px`"
    />

    <remote-cascader
      v-if="field.type === 'remotecascader'"
      v-model:value="model"
      v-model:label="labelModel"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :label-key="field.labelKey"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :search_config="field.search_config"
      :value-key="field.valueKey"
      :style="`width: ${field_width}px`"
    />
    <remote-cascader-pro
      v-if="field.type === 'remotecascaderpro'"
      v-model:label="labelModel"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :field="field"
      :formModel="formModel"
      :outModel="outModel"
      :get-data="field.getData"
      :multiple="field.multiple"
      :maxTagCount="field.maxTagCount ? field.maxTagCount : 'responsive'"
      :show_search="field.show_search"
      :label-key-type="field.labelKeyType"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :label-key="field.labelKey"
      :value-key="field.valueKey"
      :init_model="field.init_model"
      :init_watch="field.init_watch"
      :is_form_design="is_form_design"
      :placeholder="
        field.placeholder_i18n == undefined
          ? field.placeholder
            ? field.placeholder
            : t('请选择') + field.label
          : t(field.placeholder_i18n)
      "
      :style="`width: ${field_width}px`"
    />

    <month-picker
      v-if="field.type === 'monthpicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      size="small"
      :is_range="field.is_range"
      :value_has_time="field.value_has_time"
      :start_offset_day="field.start_offset_day"
      :end_offset_day="field.end_offset_day"
      :fix_day="field.fix_day"
      :style="`width: ${field_width}px`"
    />
    <a-date-picker
      v-if="field.type === 'datepicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :format="field.format"
      :picker="field.picker"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      :show-time="field.showTime"
      :value-format="field.valueFormat"
      size="small"
      :style="`width: ${field_width}px`"
    />

    <a-range-picker
      v-if="field.type === 'rangepicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue || []"
      :disabled="field.disabled"
      :format="field.format"
      :placeholder="
        field.placeholder && isArray(field.placeholder) && field.placeholder.length > 0
          ? field.placeholder
          : [$t('开始时间'), $t('结束时间')]
      "
      :show-time="field.showTime"
      :value-format="field.valueFormat"
      :picker="field.picker ? field.picker : 'date'"
      size="small"
      :style="`width: ${field_width}px`"
    />

    <month-range-picker
      v-if="field.type === 'monthrangepicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue || []"
      :disabled="field.disabled"
      :placeholder="field.placeholder"
      size="small"
      :is_range="field.is_range"
      :value_has_time="field.value_has_time"
      :start_offset_day="field.start_offset_day"
      :end_offset_day="field.end_offset_day"
      :fix_day="field.fix_day"
      :style="`width: ${field_width}px`"
    />

    <a-time-picker
      v-if="field.type === 'timepicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :format="field.format ? field.format : 'HH:mm'"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      :value-format="field.valueFormat ? field.valueFormat : 'HH:mm'"
      size="small"
      :style="`width: ${field_width}px`"
    />
    <a-time-range-picker
      v-if="field.type === 'timerangepicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :format="field.format ? field.format : 'HH:mm'"
      :placeholder="
        field.placeholder && isArray(field.placeholder) && field.placeholder.length > 0
          ? field.placeholder
          : [$t('开始时间'), $t('结束时间')]
      "
      :value-format="field.valueFormat ? field.valueFormat : 'HH:mm'"
      size="small"
      :style="`width: ${field_width}px`"
    />
    <a-radio-group
      v-if="field.type === 'radio'"
      v-model:value="model"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      size="small"
      :style="`width: ${field_width}px`"
    >
      <a-radio
        v-for="option in options"
        :key="option[field.valueKey ? field.valueKey : 'value']"
        :disabled="option.disabled"
        :value="option[field.valueKey ? field.valueKey : 'value']"
      >
        {{ option[field.labelKey ? field.labelKey : 'label'] }}
      </a-radio>
    </a-radio-group>

    <a-checkbox-group
      v-if="field.type === 'checkbox'"
      v-model:value="model"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      size="small"
      :style="`width: ${field_width}px`"
    >
      <a-checkbox
        v-for="option in options"
        :key="option[field.valueKey ? field.valueKey : 'value']"
        :disabled="option.disabled"
        :value="option[field.valueKey ? field.valueKey : 'value']"
      >
        {{ option[field.labelKey ? field.labelKey : 'label'] }}
      </a-checkbox>
    </a-checkbox-group>

    <a-tree-select
      v-if="field.type === 'treeselect'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :dropdownMatchSelectWidth="false"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      :multiple="field.multiple"
      :tree-checkable="field.treeCheckable"
      :tree-data="options"
      :tree-label-prop="field.labelKey"
      :tree-node-filter-prop="field.valueKey"
      size="small"
      :style="`width: ${field_width}px`"
    />
    <remote-filter-select
      v-if="field.type === 'remotefilterselect'"
      v-model:label="labelModel"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :init_model="field.init_model"
      :label-key="field.labelKey"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :search_config="field.search_config"
      :value-key="field.valueKey"
      :style="`width: ${field_width}px`"
    />
    <remote-select
      v-if="field.type === 'remoteselect'"
      v-model:label="labelModel"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :init_model="field.init_model"
      :label-key="field.labelKey"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :search_config="field.search_config"
      :value-key="field.valueKey"
      :style="`width: ${field_width}px`"
    />
    <remote-select-pro
      v-if="field.type === 'remoteselectpro'"
      v-model:label="labelModel"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :outModel="outModel"
      :get-data="field.getData"
      :init_model="field.init_model"
      :init_watch="field.init_watch"
      :label-key="field.labelKey"
      :label-key-type="field.labelKeyType"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :search_config="field.search_config"
      :value-key="field.valueKey"
      :is_input="field.is_input"
      :is_form_design="is_form_design"
      :placeholder="
        field.placeholder_i18n == undefined
          ? field.placeholder
            ? field.placeholder
            : $t('请选择') + field.label
          : t(field.placeholder_i18n)
      "
      :style="`width: ${field_width}px`"
    />
    <remote-complete
      v-if="field.type === 'remotecomplete'"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :outModel="outModel"
      :get-data="field.getData"
      :init_model="field.init_model"
      :init_watch="field.init_watch"
      :label-key="field.labelKey"
      :label-key-type="field.labelKeyType"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :search_config="field.search_config"
      :value-key="field.valueKey"
      :maxlength="field.maxlength"
      :is_input="field.is_input"
      :is_form_design="is_form_design"
      :placeholder="
        field.placeholder_i18n == undefined
          ? field.placeholder
            ? field.placeholder
            : $t('请选择') + field.label
          : t(field.placeholder_i18n)
      "
      :style="`width: ${field_width}px`"
    />
    <remote-tree-select
      v-if="field.type === 'remotetreeselect'"
      v-model:label="labelModel"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :label-key="field.labelKey"
      :search_config="field.search_config"
      :value-key="field.valueKey"
      :style="`width: ${field_width}px`"
    />
    <remote-tree-select-pro
      v-if="field.type === 'remotetreeselectpro'"
      v-model:label="labelModel"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :field="field"
      :formModel="formModel"
      :outModel="outModel"
      :get-data="field.getData"
      :multiple="field.multiple"
      :search_config="field.search_config"
      :label-key-type="field.labelKeyType"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :label-key="field.labelKey"
      :value-key="field.valueKey"
      :init_model="field.init_model"
      :init_watch="field.init_watch"
      :is_form_design="is_form_design"
      :placeholder="
        field.placeholder_i18n == undefined
          ? field.placeholder
            ? field.placeholder
            : $t('请选择') + field.label
          : t(field.placeholder_i18n)
      "
      :style="`width: ${field_width}px`"
    />
    <remote-modal
      v-if="field.type === 'remotemodal'"
      v-model:label="labelModel"
      v-model:value="model"
      :columns="field.columns"
      :field="field"
      :field_status="field.field_status"
      :get-data="field.getData"
      :init_model="field.init_model"
      :modalType="field.modalType"
      :search_config="field.search_config"
      :watch="field.watch"
      :style="`width: ${field_width}px`"
    />
    <remote-table
      v-if="field.type === 'remotetable'"
      v-model:value="model"
      :columns="field.columns"
      :formModel="formModel"
      :field="field"
      :field_status="field.field_status"
      :get-data="field.getData"
      :init_model="field.init_model"
      :modalType="field.modalType"
      :search_config="field.search_config"
      :watch="field.watch"
      :style="`width: ${field_width}px`"
    />

    <remote-text
      v-if="field.type === 'remotetext'"
      v-model:value="model"
      :columns="field.columns"
      :formModel="formModel"
      :field="field"
      :get-data="field.getData"
      :init_model="field.init_model"
      :modalType="field.modalType"
      :search_config="field.search_config"
      :watch="field.watch"
    />

    <a-rate
      v-if="field.type === 'rate'"
      v-model:value="model"
      :count="field.count ? field.count : 5"
      :allow-half="field.allowHalf"
      :style="`width: ${field_width}px`"
    />
    <a-radio-group
      v-if="field.type === 'radio-color'"
      v-model:value="model"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      size="small"
      :style="`width: ${field_width}px`"
    >
      <a-radio
        v-for="option in options"
        :key="option[field.valueKey ? field.valueKey : 'value']"
        :disabled="option.disabled"
        :value="option[field.valueKey ? field.valueKey : 'value']"
      >
        <div
          :style="{
            width: '20px',
            height: '20px',
            backgroundColor: option[field.valueKey ? field.valueKey : 'value'],
          }"
        ></div>
      </a-radio>
    </a-radio-group>
  </template>

  <a-divider
    v-if="field.type === 'divider'"
    :orientation="field.orientation"
  >
    {{ field.label }}
  </a-divider>
</template>
<script lang="ts">
import RemoteSelect from 'liyu-pc-base/components/FormRender/RemoteSelect/RemoteSelect.vue';
import RemoteCascader from 'liyu-pc-base/components/FormRender/RemoteCascader/RemoteCascader.vue';
import RemoteModal from 'liyu-pc-base/components/FormRender/RemoteModal/RemoteModal.vue';
import RemoteTreeSelect from 'liyu-pc-base/components/FormRender/RemoteTreeSelect/RemoteTreeSelect.vue';
import RemoteTable from 'liyu-pc-base/components/FormRender/RemoteTable/RemoteTable.vue';
import { defineComponent, watch, onMounted, ref } from 'vue';
import RemoteFilterSelect from 'liyu-pc-base/components/FormRender/RemoteFilterSelect/RemoteFilterSelect.vue';
import AttributeNomTable from 'liyu-pc-base/components/FormRender/AttributeNomTable/index.vue';
import AttributeTable from 'liyu-pc-base/components/FormRender/AttributeTable/index.vue';
import JsonStr from 'liyu-pc-base/components/FormRender/JsonStr/index.vue';
import JsonObj from 'liyu-pc-base/components/FormRender/JsonObj/index.vue';
import RemoteText from 'liyu-pc-base/components/FormRender/RemoteText/RemoteText.vue';
import RemoteTablePro from 'liyu-pc-base/components/FormRender/RemoteTablePro/RemoteTablePro.vue';
import { debounce, isArray, isEqual } from 'lodash-es';
import moment from 'moment';
import { isEmpty, isNotEmpty } from 'liyu-pc-base/utils/function';
import { PlusOutlined } from '@ant-design/icons-vue';
import RemoteSelectPro from 'liyu-pc-base/components/FormRender/RemoteSelectPro/RemoteSelectPro.vue';
import RemoteComplete from 'liyu-pc-base/components/FormRender/RemoteComplete/RemoteComplete.vue';
import RemoteTreeSelectPro from 'liyu-pc-base/components/FormRender/RemoteTreeSelectPro/RemoteTreeSelectPro.vue';
import RemoteCascaderPro from 'liyu-pc-base/components/FormRender/RemoteCascaderPro/RemoteCascaderPro.vue';
import Upload from 'liyu-pc-base/components/FormRender/Upload/upload.vue';
import RichTextEditor from 'liyu-pc-base/components/FormRender/RichTextEditor/index.vue';
import { useI18n } from 'vue-i18n';
import IconSelect from 'liyu-pc-base/components/FormRender/iconSelect/index.vue';
import MonthPicker from 'liyu-pc-base/components/FormRender/MonthPicker/index.vue';
import MonthRangePicker from 'liyu-pc-base/components/FormRender/MonthRangePicker/index.vue';
import CodeEditor from 'liyu-pc-base/components/code/CodeEditor.vue';
import TinymceEditor from 'liyu-pc-base/components/tinymce/TinymceEditor.vue';

const isValidDate = (dateString, format = 'YYYY-MM-DD') => {
  const date = moment(dateString, format, true);
  return date.isValid();
};
const isValidDateTime = (dateString, format = 'YYYY-MM-DD HH:mm:ss') => {
  const date = moment(dateString, format, true);
  return date.isValid();
};
const isValidTime = (dateString, format = 'HH:mm:ss') => {
  const date = moment(dateString, format, true);
  return date.isValid();
};
export default defineComponent({
  name: 'FieldRender2',
  methods: { isArray },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    label: {
      required: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    validateInfos: {
      type: Object,
      default: () => {},
    },
    formModel: {
      type: Object,
      default: () => {},
    },
    outModel: {
      type: Object,
      default: () => {},
    },
    field_render_show: {
      type: Boolean,
      default: true,
    },
    is_show_label: {
      type: Boolean,
      default: true,
    },
    isUseConditions: {
      type: Boolean,
      default: true,
    },
    is_show_field: {
      type: Boolean,
      default: true,
    },
    is_edit: {
      type: Boolean,
      default: true,
    },
    conditionsVisibleNum: {
      type: Number,
      default: 0,
    },
    is_form_design: {
      type: Boolean,
      default: false,
    },
    field_width: {
      type: Number,
      default: 150,
    },
  },
  emits: [
    'add',
    'update:value',
    'update:label',
    'update_model',
    'update:is_show_field',
    'update:is_edit',
    'update_name2',
  ],
  setup(props, { emit }) {
    const newModel = ref({ ...props.formModel });
    const rangeDate = (v: any) => {
      if (typeof v == 'string' && v.indexOf(',') >= 0) {
        return v.split(',');
      }
      return v;
    };
    const convertValueByClassName = (value, class_name) => {
      //class_name 'int','float',str','bool','date','datetime','time'
      let new_value;
      if (class_name == 'int') {
        if (isNotEmpty(value) && value instanceof Array) {
          new_value = [];
          value.forEach(item => {
            if (isNotEmpty(item) && typeof item === 'string') {
              new_value.push(Number(item));
            } else {
              new_value.push(item);
            }
          });
        } else if (isNotEmpty(value) && typeof value === 'string') {
          new_value = Number(value);
        } else {
          new_value = value;
        }
      } else if (class_name == 'str') {
        if (isNotEmpty(value) && value instanceof Array) {
          new_value = [];
          value.forEach(item => {
            if (isNotEmpty(item) && typeof item === 'number') {
              new_value.push(item.toString());
            } else {
              new_value.push(item);
            }
          });
        } else if (isNotEmpty(value) && typeof value === 'number') {
          new_value = value.toString();
        } else {
          new_value = value;
        }
      } else if (class_name == 'date') {
        if (isNotEmpty(value) && value instanceof Array) {
          new_value = [];
          value.forEach(item => {
            if (isValidDate(item) && typeof item === 'string') {
              new_value.push(moment(item, 'YYYY-MM-DD'));
            } else {
              new_value.push(item);
            }
          });
        } else if (isValidDate(value) && typeof value === 'string') {
          new_value = value.toString();
        } else {
          new_value = value;
        }
      } else if (class_name == 'datetime') {
        if (isNotEmpty(value) && value instanceof Array) {
          new_value = [];
          value.forEach(item => {
            if (isValidDateTime(item) && typeof item === 'string') {
              new_value.push(moment(item, 'YYYY-MM-DD HH:mm:ss'));
            } else {
              new_value.push(item);
            }
          });
        } else if (isValidDateTime(value) && typeof value === 'string') {
          new_value = moment(value, 'YYYY-MM-DD HH:mm:ss');
        } else {
          new_value = value;
        }
      } else if (class_name == 'time') {
        if (isNotEmpty(value) && value instanceof Array) {
          new_value = [];
          value.forEach(item => {
            if (isValidTime(item) && typeof item === 'string') {
              new_value.push(moment(item, 'HH:mm:ss'));
            } else {
              new_value.push(item);
            }
          });
        } else if (isValidTime(value) && typeof value === 'string') {
          new_value = moment(value, 'HH:mm:ss');
        } else {
          new_value = value;
        }
      } else if (class_name == 'float') {
        if (isNotEmpty(value) && value instanceof Array) {
          new_value = [];
          value.forEach(item => {
            if (isNotEmpty(item) && typeof item === 'string') {
              new_value.push(Number(item));
            } else {
              new_value.push(item);
            }
          });
        } else if (isNotEmpty(value) && typeof value === 'string') {
          new_value = Number(value);
        } else {
          new_value = value;
        }
      } else if (class_name == 'bool') {
        if (isNotEmpty(value) && value instanceof Array) {
          new_value = [];
          value.forEach(item => {
            if (isNotEmpty(item) && typeof item === 'string') {
              new_value.push(Boolean(item));
            } else {
              new_value.push(item);
            }
          });
        } else if (isNotEmpty(value) && typeof value === 'string') {
          new_value = Boolean(value);
        } else {
          new_value = value;
        }
      }
      return new_value;
    };
    const is_show_field = ref(props.is_show_field);
    const is_edit = ref(false);
    const handleToggleEdit = () => {
      emit('update:is_edit', is_edit.value);
    };
    const handleAdd = () => {
      emit('add');
    };
    const check_visible_field_fun = debounce(() => {
      const old_is_show_field = is_show_field.value;
      const condition_result_list: any = [];
      for (const i in props.field?.conditions) {
        const group_list = props.field?.conditions[i];
        const group_results = [];
        for (const j in group_list) {
          const item = group_list[j];
          const value = props.formModel[item.watchKey];
          let new_value;
          if (item.class_name) {
            new_value = convertValueByClassName(item.value, item.class_name);
          } else {
            new_value = item.value;
          }
          let first, second;
          if (new_value instanceof Array) {
            [first, second] = new_value;
          }
          if (item.operator == 'lt') {
            if (typeof first === 'number') {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (value < first) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            } else if (isValidDate(first)) {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (moment(value).isBefore(moment(first))) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            }
          } else if (item.operator == 'lte') {
            if (typeof first === 'number') {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (value <= first) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            } else if (isValidDate(first)) {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (
                moment(value).isBefore(moment(first)) ||
                moment(value).isSame(moment(first))
              ) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            }
          } else if (item.operator == 'gt') {
            if (typeof first === 'number') {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (value > first) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            } else if (isValidDate(first)) {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (moment(value).isAfter(moment(first))) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            }
          } else if (item.operator == 'gte') {
            if (typeof first === 'number') {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (value >= first) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            } else if (isValidDate(first)) {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (
                moment(value).isAfter(moment(first)) ||
                moment(value).isSame(moment(first))
              ) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            }
          } else if (item.operator == 'between') {
            if (typeof first === 'number' && typeof second === 'number' && first && second) {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (value >= first && value <= second) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            } else if (isValidDate(first)) {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (
                (moment(value).isAfter(moment(first)) || moment(value).isSame(moment(first))) &&
                (moment(value).isBefore(moment(second)) || moment(value).isSame(moment(second)))
              ) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            }
          } else if (item.operator == 'notbetween') {
            if (typeof first === 'number' && typeof second === 'number' && first && second) {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (value < first || value > second) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            } else if (isValidDate(first)) {
              if (isEmpty(value)) {
                group_results.push(false);
              } else if (
                moment(value).isBefore(moment(first)) ||
                moment(value).isAfter(moment(second))
              ) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            }
          } else if (item.operator == 'in') {
            if (value instanceof Array) {
              const f_list = new_value.filter(x => {
                return value.includes(x);
              });
              if (f_list.length > 0) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            } else if (typeof value == 'string' || typeof value == 'number' || isEmpty(value)) {
              // 数字 字符串 空
              const f = new_value.find(x => {
                return value == x;
              });
              if (f) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            }
          } else if (item.operator == 'eq') {
            if (value === first) {
              group_results.push(true);
            } else {
              group_results.push(false);
            }
          } else if (item.operator == 'contains') {
            if (value.toString().indexOf(first) > -1) {
              group_results.push(true);
            } else {
              group_results.push(false);
            }
          } else if (item.operator == 'startswith') {
            if (value.toString().startsWith(first)) {
              group_results.push(true);
            } else {
              group_results.push(false);
            }
          } else if (item.operator == 'notin') {
            if (value instanceof Array) {
              const f_list = new_value.filter(x => {
                return value.includes(x);
              });
              if (f_list.length > 0) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            } else if (typeof value == 'string' || typeof value == 'number' || isEmpty(value)) {
              // 数字 字符串 空
              const f = new_value.find(x => {
                return value == x;
              });
              if (!f) {
                group_results.push(true);
              } else {
                group_results.push(false);
              }
            }
          } else if (item.operator == 'notcontains') {
            if (value.toString().indexOf(first) == -1) {
              group_results.push(true);
            } else {
              group_results.push(false);
            }
          } else if (item.operator == '_eq') {
            //todo
          } else if (item.operator == 'json_list_not_blank_not_null') {
            // 非空
            if (value) {
              group_results.push(true);
            } else {
              group_results.push(false);
            }
          } else if (item.operator == 'json_list_is_blank_is_null') {
            //为空
            if (!value) {
              group_results.push(true);
            } else {
              group_results.push(false);
            }
          } else if (item.operator == 'not_eq') {
            //为空
            if (!value) {
              group_results.push(true);
            } else {
              group_results.push(false);
            }
          } else if (item.operator == 'not_blank_not_null') {
            // 非空
            if (value) {
              group_results.push(true);
            } else {
              group_results.push(false);
            }
          }
        }
        condition_result_list.push(group_results);
      }
      const con_list = [];
      condition_result_list.forEach(item => {
        const find_false_list = item.filter(x => x === false);
        if (find_false_list && find_false_list.length > 0) {
          con_list.push(false);
        } else {
          con_list.push(true);
        }
      });

      const find_true_list = con_list.filter(x => x === true);
      if (find_true_list && find_true_list.length > 0) {
        is_show_field.value = true;
        emit('update:is_show_field', is_show_field.value);
      } else {
        is_show_field.value = false;
        emit('update:is_show_field', is_show_field.value);
      }
      if (is_show_field.value !== old_is_show_field) {
        if (is_show_field.value) {
          newModel.value[props.field.name] = null;
          emit('update_model', {
            add_key: props.field.name,
            value: null,
          });
        } else {
          delete newModel.value[props.field.name];
          emit('update_model', {
            remove_key: props.field.name,
          });
        }
      }
    }, 300);
    const model = ref<any>('');
    const labelModel = ref(props.label);
    watch(
      () => model.value,
      (newValue, oldValue) => {
        if (isEqual(newValue, oldValue)) {
          return;
        }
        emit('update:value', newValue);
        if (props.field.name2) {
          let label: any;
          if (props.field.type === 'radio') {
            const obj = props.options.find(
              (item: any) =>
                item[props.field.valueKey ? props.field.valueKey : 'value'] == newValue,
            );
            label = obj?.[props.field.labelKey ? props.field.labelKey : 'label'];
          } else if (props.field.type === 'checkbox' && newValue && newValue.length >= 0) {
            const list = [];
            props.options.forEach((item: any) => {
              newValue.forEach((item1: any) => {
                if (item1 == item?.[props.field.valueKey ? props.field.valueKey : 'value']) {
                  list.push(item?.[props.field.labelKey ? props.field.labelKey : 'label']);
                }
              });
            });
            label = list.toString();
          } else if (props.field.type === 'select') {
            if (isArray(newValue)) {
              const list = [];
              props.options.forEach((item: any) => {
                newValue.forEach((item1: any) => {
                  if (item1 == item?.[props.field.valueKey ? props.field.valueKey : 'value']) {
                    list.push(item?.[props.field.labelKey ? props.field.labelKey : 'label']);
                  }
                });
              });
              label = list.toString();
            } else {
              const obj = props.options.find(
                (item: any) =>
                  item[props.field.valueKey ? props.field.valueKey : 'value'] == newValue,
              );
              label = obj?.[props.field.labelKey ? props.field.labelKey : 'label'];
            }
          }
          emit('update_name2', {
            key: props.field.name2,
            value: label,
          });
        }
      },
      { deep: true },
    );
    watch(
      () => props.value,
      newValue => {
        let value = newValue;
        if (props.field.type === 'rangepicker' && value) {
          value = rangeDate(value);
        } else if (props.field.type === 'input' && value) {
          value = value.toString().replace(/(^\s*)|(\s*$)/g, '');
        }
        if (is_show_field.value) {
          //当该表单项显示时，才做向上的数据绑定，避免把undefined向上传递,影响rules字段的有效过滤
          model.value = value;
        }
      },
      { immediate: true },
    );
    watch(
      () => labelModel.value,
      newValue => {
        emit('update:label', newValue);
        if ('name2' in props.field) {
          emit('update_name2', { key: props.field.name2, value: newValue.toString() });
        }
      },
      { deep: true },
    );
    watch(
      () => props.label,
      newValue => {
        labelModel.value = newValue;
      },
    );
    watch(
      () => props.formModel,
      newValue => {
        newModel.value = { ...newValue };
      },
      { deep: true },
    );
    watch(
      () => newModel.value,
      (newValue, oldValue) => {
        if (props.field?.conditions) {
          props.field?.conditions.forEach(condition_list => {
            condition_list.forEach(item => {
              if (oldValue[item.watchKey] != newValue[item.watchKey]) {
                check_visible_field_fun();
              }
            });
          });
        }
      },
      { deep: true },
    );
    watch(
      () => [props.conditionsVisibleNum, props.isUseConditions],
      () => {
        if (props.field?.conditions) {
          if (props.isUseConditions) {
            check_visible_field_fun();
          } else {
            is_show_field.value = true;
            emit('update:is_show_field', is_show_field.value);
          }
        } else {
          is_show_field.value = true;
          emit('update:is_show_field', is_show_field.value);
        }
      },
    );
    onMounted(() => {
      if (props.field?.conditions instanceof Array && props.field?.conditions.length > 0) {
        check_visible_field_fun();
      } else {
        is_show_field.value = true;
        emit('update:is_show_field', is_show_field.value);
      }
      if (!is_show_field.value) {
        // 表单项所见即所得，如果有隐藏的字段，那么model的key也要清除
        delete newModel.value[props.field.name];
        emit('update_model', {
          remove_key: props.field.name,
        });
      }
    });
    const { t } = useI18n();
    return {
      t,
      is_show_field,
      is_edit,
      handleToggleEdit,
      rangeDate,
      handleAdd,
      model,
      labelModel,
    };
  },
  components: {
    IconSelect,
    RichTextEditor,
    Upload,
    RemoteCascaderPro,
    RemoteTreeSelectPro,
    RemoteSelectPro,
    RemoteComplete,
    AttributeTable,
    AttributeNomTable,
    RemoteFilterSelect,
    RemoteModal,
    RemoteSelect,
    RemoteCascader,
    RemoteTreeSelect,
    RemoteTable,
    JsonStr,
    JsonObj,
    RemoteText,
    RemoteTablePro,
    PlusOutlined,
    MonthPicker,
    MonthRangePicker,
    CodeEditor,
    TinymceEditor,
  },
});
</script>

<style scoped>
.ant-calendar-picker {
  width: 100% !important;
}
</style>
